<div>
  <form [formGroup]="formGroup">
    <div class="p-fluid formgrid grid">

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="userId">
          {{'AdminUsersManagement.CreateEditUser.IdLabel' | translate}}
        </label>
        <input
          id="userId"
          formControlName="userId"
          type="text"
          pInputText
          class="custom-input bg-form"/>
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="contactName">
          {{'AdminUsersManagement.CreateEditUser.ContactNameLabel' | translate}}
        </label>
        <input
          id="contactName"
          formControlName="contactName"
          type="text"
          pInputText
          class="custom-input bg-form"/>
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="contactLastName">
          {{'AdminUsersManagement.CreateEditUser.ContactLastNameLabel' | translate}}
        </label>
        <input
          id="contactLastName"
          formControlName="contactLastName"
          type="text"
          pInputText
          class="custom-input bg-form"/>
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="profileType">
          {{'AdminUsersManagement.CreateEditUser.RoleLabel' | translate}}
        </label>
        <p-dropdown
          inputId="profileType"
          formControlName="profileType"
          [options]="profileTypeOptions"
          optionLabel="label"
          optionValue="value"
          class="custom-dropdown bg-form"></p-dropdown>
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="companyName">
          {{'AdminUsersManagement.CreateEditUser.CompanyLabel' | translate}}
        </label>
        <input
          pInputText
          id="companyName"
          formControlName="companyName"
          type="text"
          class="custom-input bg-form"/>
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="contactPhone">
          {{'AdminUsersManagement.CreateEditUser.PhoneLabel' | translate}}
        </label>
        <input
          id="contactPhone"
          formControlName="contactPhone"
          type="text"
          pInputText
          class="custom-input bg-form"/>
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="vat">
          {{'AdminUsersManagement.CreateEditUser.VatIdLabel' | translate}}
        </label>
        <input
          pInputText
          id="vat"
          formControlName="vat"
          type="text"
          class="custom-input bg-form"/>
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="contactAddress">
          {{'AdminUsersManagement.CreateEditUser.AddressLabel' | translate}}
        </label>
        <input
          id="contactAddress"
          formControlName="contactAddress"
          type="text"
          pInputText
          class="custom-input bg-form"/>
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="contactCity">
          {{'AdminUsersManagement.CreateEditUser.CityLabel' | translate}}
        </label>
        <input
          id="contactCity"
          formControlName="contactCity"
          type="text"
          pInputText
          class="custom-input bg-form"/>
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="legalRepresentativeName">
          {{'AdminUsersManagement.CreateEditUser.LegalRepresentativeNameLabel' | translate}}
        </label>
        <input
          pInputText
          id="legalRepresentativeName"
          formControlName="legalRepresentativeName"
          type="text"
          class="custom-input bg-form"/>
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="legalRepresentativeNumber">
          {{'AdminUsersManagement.CreateEditUser.LegalRepresentativeIdLabel' | translate}}
        </label>
        <input
          pInputText
          id="legalRepresentativeNumber"
          formControlName="legalRepresentativeNumber"
          class="custom-input bg-form"/>
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="country">
          {{'AdminUsersManagement.CreateEditUser.CountryLabel' | translate}}
        </label>
        <p-dropdown id="contactCountry"
          formControlName="contactCountryId"
          [options]="countries"
          optionValue="id"
          optionLabel="name"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          class="custom-dropdown bg-form">
        </p-dropdown>
      </div>

      <div class="field col-12"></div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3" *ngIf="profile?.type == 1">
        <p-button
          label="{{'AdminUsersManagement.Table.ImportersButton' | translate}}"
          (onClick)="onOpenImportersAssociationDialog()"
          styleClass="p-button-outlined p-button-secondary"
          class="custom-text-button secondary-filled"/>
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <p-button
          label="{{'AdminUsersManagement.CreateConsigneeButton' | translate}}"
          (onClick)="createConsigneeOrNotifier('Consignee')"
          class="custom-text-button"/>
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <p-button
          label="{{'AdminUsersManagement.CreateNotifierButton' | translate}}"
          (onClick)="createConsigneeOrNotifier('Notifier')"
          class="custom-text-button"/>
      </div>

      <div class="field col-12 md:col-offset-10 md:col-2 mt-4">
        <p-button
          label="{{'AdminUsersManagement.Messages.CloseButton' | translate}}"
          (onClick)="cancel()"
          styleClass="p-button-outlined"
          class="custom-text-button"/>
      </div>
    </div>
  </form>
</div>

<p-dialog
  header="{{'AdminUsersManagement.ExporterAssociation.DialogTitle' | translate}}"
  [(visible)]="showImportersAssociationDialog"
  [style]="{width: '100%', minHeight: '40rem'}"
  [modal]="true"
  [draggable]="false"
  [resizable]="false">

  <div *ngIf="showImportersAssociationDialog">
    <app-admin-exporter-importers-page
      [exporterProfile]="profile"
      (closeDialog)="onCloseImportersAssociationDialog()"
    />
  </div>
</p-dialog>
